import React from "react";
import HalalHeader from "../../../components/Compliance Certificates/Halal/HalalHeader";
import HalalInfoContainer from "../../../components/Compliance Certificates/Halal/HalalInfoContainer";

const Halal = () => {
  return (
    <div>
      <HalalHeader />
      <HalalInfoContainer />
    </div>
  );
};

export default Halal;
